import { ChangeDetectionStrategy, ViewEncapsulation, Component, Input } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzTimePickerComponent } from 'ng-zorro-antd/time-picker';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NgIf } from '@angular/common';

import { BaseFormFieldComponent, baseProviderComponent } from '../base-form-field.component';
import { FormFieldDateModeType, IFormFieldTimeConfig } from '../../models';
import { LocalizationPipe } from '@shared/modules/localization';
import { DateUtils, TimeFormatType } from '@shared/core';

@Component({
  selector: 'ui-form-time',
  templateUrl: './form-time.component.html',
  styleUrl: './form-time.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    NzTimePickerComponent,
    ReactiveFormsModule,
    NzDatePickerModule,
    LocalizationPipe,
    NzFormModule,
    FormsModule,
    NgIf,
  ],
  providers: baseProviderComponent(UIFormTime),
})
export class UIFormTime extends BaseFormFieldComponent<string | Date | null> {
  hourValue?: number;
  minuteValue?: number;

  timeControl = new FormControl();

  @Input() override value: string | Date | null = '';
  @Input() override set config(configValue: IFormFieldTimeConfig) {
    this.label = configValue.label;
    this.placeholder = configValue.placeholder ?? '';
    this.hideLabel = configValue.hideLabel ?? false;
    this.required = !!configValue.required;
    this.format = configValue.format ?? 'HH:mm';
    this.loading = configValue.loading ?? false;
  }

  time = new Date();
  @Input() mode: FormFieldDateModeType = 'date';
  @Input() showTime?: boolean;
  @Input() format: TimeFormatType = 'HH:mm';
  @Input() maxDateOrCurrent?: Date | boolean;
  @Input() minDateOrCurrent?: Date | boolean;

  ngOnInit(): void {
    this.timeControl.setValidators(this.control?.validator ?? []);
    const timeValue = this.control?.value;

    if (timeValue) {
      const date = DateUtils.isValidDate(timeValue)
        ? new Date(timeValue)
        : DateUtils.convertToDateTime(timeValue);
      this.timeControl.setValue(date);
      this.initSelectedValues(date);
    }
  }

  private initSelectedValues(date: Date): void {
    this.hourValue = date.getHours();
    this.minuteValue = this.roundToNearestFive(date.getMinutes());
  }

  onDateChanged(value: Date | null): void {
    this.value = value?.toISOString() ?? null;
    this.onChange(this.value);
    this.updateControlValidity();
  }

  roundToNearestFive(num: number): number {
    return Math.round(num / 5) * 5;
  }
}
